import { useState } from 'react';
import { Position } from 'reactflow';
import { BaseNode, NodeField, NodeInput, NodeSelect } from './baseNode';

export const FilterNode = ({ id, data }) => {
  const [field, setField] = useState(data?.field || '');
  const [operator, setOperator] = useState(data?.operator || 'contains');
  const [value, setValue] = useState(data?.value || '');
  // The 'top' percentages move the red dots down to align with the text.
  const handles = [
    { type: 'target', position: Position.Left,  id: `${id}-input`, style: { top: '50%' } },
    { type: 'source', position: Position.Right, id: `${id}-pass`,  style: { top: '78%' } }, 
    { type: 'source', position: Position.Right, id: `${id}-fail`,  style: { top: '92%' } }, 
  ];

  return (
    <BaseNode label="Filter" color="#ef4444" handles={handles} width={220}>
      <NodeField label="Field">
        <NodeInput value={field} onChange={e => setField(e.target.value)} placeholder="e.g. status" />
      </NodeField>
      
      <NodeField label="Operator">
        <NodeSelect value={operator} onChange={e => setOperator(e.target.value)}>
          <option value="equals">Equals</option>
          <option value="contains">Contains</option>
          <option value="greater">Greater Than</option>
          <option value="less">Less Than</option>
        </NodeSelect>
      </NodeField>
      
      <NodeField label="Value">
        <NodeInput value={value} onChange={e => setValue(e.target.value)} placeholder="e.g. success" />
      </NodeField>

      {/* Connection Labels */}
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4, marginTop: 4, fontSize: 10 }}>
        <span style={{ color: '#16a34a', fontWeight: 600 }}>pass →</span>
        <span style={{ color: '#dc2626', fontWeight: 600 }}>fail →</span>
      </div>
    </BaseNode>
  );
};